import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";

/**
 * @class CompoundIntentTag
 */
export default class CompoundIntentTag extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            showJsx: false,
            showModuleEditDropDown: false,
            isModuleEdit: false
        };
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    removeSubmenu() {
        this.setState({ showJsx: false });
    }

    initEditMapping(event, valKey) {
        event.preventDefault();
        event.stopPropagation();
        // const a = event.target.offsetParent.previousElementSibling.offsetTop - 2;
        //const b = event.target.offsetParent.previousElementSibling.offsetLeft;
        //const c = event.target.offsetParent.previousElementSibling.offsetWidth - 1;
        const x = event.target.offsetParent.offsetTop - 2;
        const y = event.target.offsetParent.offsetLeft;
        const w = event.target.offsetParent.offsetWidth - 1;
        const dataset = this.props.data;

        this.props.context.setSelectedIntentListItem(JSON.parse(JSON.stringify(dataset)));
        this.props.context.initEditMappingDropdown(x, y, w, valKey);

        this.setState({ 'isModuleEdit': true });
    }

    completeEditMapping() {
        this.setState({ 'isModuleEdit': false });
    }

    render() {
        var toIntName = <b>???</b>;
        var fromIntName1 = "<UNKNOWN: " + this.props.data.fromIntent1.substring(this.props.data.fromIntent1.length - 6) + ">";
        var fromIntName2 = <b>???</b>;
        var greyInt = true;

        var greyMod = true;
        const toInt = window.apm.getNode(this.props.data.toIntent);
        const fromInt1 = window.apm.getNode(this.props.data.fromIntent1);
        const fromInt2 = window.apm.getNode(this.props.data.fromIntent2);

        if (toInt) {
            if (toInt.name.length > 20) toIntName = toInt.name.substring(0, 20) + "…";
            else toIntName = toInt.name;

            greyInt = false;
        }
        if (fromInt1) {
            if (fromInt1.name.length > 20) fromIntName1 = fromInt1.name.substring(0, 20) + "…";
            else fromIntName1 = fromInt1.name;
            greyInt = false;
        }
        if (fromInt2) {
            if (fromInt2.name.length > 20) fromIntName2 = fromInt2.name.substring(0, 20) + "…";
            else fromIntName2 = fromInt2.name;
            greyInt = false;
        }

        return (

            <li
                data-id={this.props.data.id}
                data-fromint1={this.props.data.fromIntent1}
                data-fromint2={this.props.data.fromIntent2}
                data-toint={this.props.data.toIntent}
                created-time={this.props.data.createdTime}
                lastsavedchange={this.props.data.lastSavedChange}
                className={"intent-row" + (greyInt && greyMod ? " greyout" : "") + (this.props.highlight ? " highlight" : "")}>
                <div className={"intent-cell"}>
                    <div className="icon-container icon-left">
                        <i className={"fe icon-compass"} />
                    </div>
                    <div className={"intent-name"}>
                        {fromIntName1}
                    </div>

                </div>
                <i className={"fe icon-plus"} />
                <div className={"intent-cell"}>

                    <div className="icon-container icon-left">
                        <i className={"fe icon-compass"} />
                    </div>
                    <div className={"intent-name"} onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.initEditMapping(event, "fromIntent2")
                    }}>
                        {fromIntName2}
                    </div>
                    <div className="icon-container icon-right">
                        <i className={"fe icon-chevrons-right"} />
                    </div>
                </div>

                <div className={"intent-cell"}>
                    <div className="icon-container icon-left">
                        <i className={"fe icon-compass"} />
                    </div>
                    <div className={"intent-name"}
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.initEditMapping(event, "toIntent")
                        }}>
                        {toIntName}
                    </div>
                    <div className="icon-container icon-right" data-intent={this.props.data}
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.initEditMapping(event, "toIntent")
                        }}
                    >
                    </div>
                    <div className="icon-container icon-right" data-intent={this.props.context.state.compoundIntents.findIndex(el => el.fromIntent1 === this.props.data.fromIntent1 && el.fromIntent2 === this.props.data.fromIntent2 && el.toIntent === this.props.data.toIntent)}
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            const intent = event.currentTarget.dataset.intent;
                            this.props.context.removeIntent(intent)
                        }}
                    >
                        <i className={"icon-delete"} />

                    </div>
                </div>
            </li>
        );
    }
}